import { isLocalUrl, validateWindowSize } from '../utils.js';

export default function cardWidget7() {
  const widgetName = 'cardWidget7';
  const widgetOpts = cardWidget7Opts;

  // you can remove this and import the validateWindowSize auxiliary function under Helpers/helpers.js
  const isDesktopScreen = validateWindowSize(800);
  const showDescription = false;
  const wrapContainerClass = 'cardWidget7-container-wrapper';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: isDesktopScreen ? [] : ['all'],
    showDescription: showDescription,
    moreButton: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 6,
    itemsPerPanel: 1,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items, showDescription);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomCards(widgetData, showDescription) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    const numberOfItems = widgetData.length;
    numberOfItems > 4
      ? $widget.addClass('more-than-4-items')
      : $widget.removeClass('more-than-4-items');

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, Description, URL } = widgetData[x];

      let urlAttribute = isLocalUrl(URL) ? '' : 'target="_blank"';

      const $cardItem = $(this);

      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
            <div class="hover-content">
              ${showDescription ? `<p class="widget-description">${Description}</p>` : ''}
              ${URL ? `<a href="${URL}" class="button" ${urlAttribute}>More</a>` : ''}
            </div>
          </div>`);

      if (isLocalUrl(URL)) {
        $cardItem.removeAttr('target');
      }

      if (!URL && !showDescription) {
        $cardItem.addClass('empty-card').removeAttr('href');
      } else if (!URL && showDescription) {
        $cardItem.addClass('just-desc').removeAttr('href');
      } else if (URL && !showDescription) {
        $cardItem.addClass('only-url');
      }
    });
  }
}
